import { Component, OnInit } from '@angular/core';
import { VolunteerSubsriptionService } from '../../Services/volunteerSubscription.service';
import { Router } from '@angular/router';
import { AuthService } from '../../Services/auth.service';

import Swal from 'sweetalert2';

// import * as $ from 'jquery';



@Component({
  selector: 'app-volunteer-subscription-list-members',
  template: require('./volunteer-subscription-list-members.component.html'),
  styles: [require('./volunteer-subscription-list-members.component.css')]
})
export class VolunteerSubscriptionListMembersComponent implements OnInit {
  
  volunteerActivities: any=[];
  MyVolunteerActivites: any=[];
  memberId:number = -1;

  constructor(  
    private auth: AuthService, 
    private volunteerSubsriptionService: VolunteerSubsriptionService,
    private router: Router 
   ) {
    this.auth.observableAuth.subscribe(item => {
      if (! this.isEmptyObject(item)){
        this.memberId = item.id
      }
    });
    }

  isEmptyObject(obj: any) {
    var name;
    for (name in obj) {
        if (obj.hasOwnProperty(name)) {
            return false;
        }
    }
    return true;
  }
  
  ngOnInit() {
   this.loadAllVolunteerActivities();
  }

  loadAllVolunteerActivities(){
    this.volunteerSubsriptionService.getAllVolunteerActivities().subscribe( (res:any)=>{
      // console.log(res);
      if (res.status == 200){
        this.volunteerActivities = res.value;
        this.refreshMyVolunteerSubscriptions()
      }
    } )
  }

  lockedClicked(){
    Swal.fire({
      type: 'info',
      title: 'Gesloten activiteit',
      text: 'Een gesloten activiteit kan alleen door het bestuur worden gewijzigd',
      confirmButtonText: 'Ok'
    })
  }

  refreshMyVolunteerSubscriptions(){
    this.volunteerSubsriptionService.getAllMemberSubscriptions(this.memberId).subscribe ( (res:any)=>{

      if (res.status == 200){
        this.MyVolunteerActivites = res.value
        this.MyVolunteerActivites.forEach( (Myva:any) => {
          var va = this.volunteerActivities.find( (va:any) => va.id === Myva.volunteerActivityId  )
          if (va != null){
            va['isSubscribed'] = true
          }         
        });
      }
      
    } )
  }

  subscribe(id: number){
    var i = this.MyVolunteerActivites.find( (s:any) => s.volunteerActivityId == id)

    if (i){
      Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je je wil uitschrijven?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.volunteerSubsriptionService.deleteSubsciptionFromActivity(i.id).subscribe ( (res:any)=>{
            this.loadAllVolunteerActivities();
          })
        }
      });
    }else{
      this.router.navigate(["subscription/volunteers/"+id+"/member"]);
    }
  }

  getRemark(id: number){
    var mySub = this.MyVolunteerActivites.find( (s:any) => s.volunteerActivityId == id);
    var myRemark = ""
    if (typeof(mySub) !== 'undefined'){
      if (mySub != null){
        // console.log("MySub: ", mySub)
        myRemark = mySub.remarks
      }
    }
    return myRemark;
  }

  showMessage(s:string){
    Swal.fire({
      showCancelButton:false,
      cancelButtonText: "Annuleren",
      title: "Opmerking: ",
      type: "info",
      input: 'textarea',
      inputAttributes: {
        "readonly": "",
        "style": "color: darkgrey;background-color: lightgrey;"
      },
      inputValue: s

    })
  }

  readDescription(id:number){
    var f = this.volunteerActivities.find( (s:any) => s.id == id);
    // console.log("readSubscription: ",f);

    // var mySub = this.MyVolunteerActivites.find( (s:any) => s.volunteerActivityId == id);
    // console.log("MySub: ", mySub)
    // var myRemark = ""

    // if (mySub != null){
    //   myRemark = mySub.remarks
    // }
    
    var title = `<Strong>Informatie ${f.subject} </strong>`;
    var description = f.description.replace(/\n/g, " <br> ");
    var html = `<div class="row mt-4">
                    <div class="col col-lg-12 text-left">
                        ${description}
                    </div>
                </div>
                `

    if (f){
      Swal.fire({
            title:title,
            html: html,
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Okay',
      });
    }
  }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/volunteer-subscription-list-members/volunteer-subscription-list-members.component.ts